'use strict'

module.exports = imageReference

var normalize = require('mdurl/encode')
var revert = require('../revert')

/* Transform a reference to an image. */
function imageReference(h, node) {
  var def = h.definition(node.identifier)
  var props

  if (!def) {
    return revert(h, node)
  }

  props = {src: normalize(def.url || ''), alt: node.alt}

  if (def.title !== null && def.title !== undefined) {
    props.title = def.title
  }

  return h(node, 'img', props)
}



//////////////////
// WEBPACK FOOTER
// ./~/remark-react/~/mdast-util-to-hast/lib/handlers/image-reference.js
// module id = 894
// module chunks = 95715928098905 168707334958949